import { CursorModule } from './../../directives/cursor/cursor.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselImagesComponent } from './carousel-images.component';
import { SvgModule } from '@app/shared/components/svg/svg.module';
import { MagnifyModule } from '@app/shared/directives/magnify/magnify.module';
import { ImagesModule } from '@app/shared/components/images/images.module';
import { SliderModule } from '@app/shared/components/slider/slider.module';
import { GalleryModule } from '@app/+product/gallery/gallery.module';
@NgModule({
  imports: [CommonModule, SvgModule, MagnifyModule, ImagesModule, SliderModule, GalleryModule, CursorModule],
  exports: [CarouselImagesComponent],
  declarations: [CarouselImagesComponent]
})
export class CarouselImagesModule {}
